import React, { useEffect, useRef, useState, useContext } from "react";
import ReactDatePicker from "react-datepicker";
import en from 'date-fns/locale/en-US';
import it from 'date-fns/locale/it';
import fr from 'date-fns/locale/fr';
import ja from 'date-fns/locale/ja';
import ko from 'date-fns/locale/ko';
import zh from 'date-fns/locale/zh-CN';
import ru from 'date-fns/locale/ru';
import { getYear, addDays, subDays } from 'date-fns';
import Select, { components } from "react-select";
import styles from "./InputBooking.module.scss";
import { Controller } from "react-hook-form";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useWindowResize from "../../hooks/useWindowResize";



const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <FontAwesomeIcon
                icon={faCaretDown}
                size="xs"
                style={{ margin: "0 .35rem", fontSize: ".65rem" }}
            />
        </components.DropdownIndicator>
    );
};

const InputBooking = ({
    text,
    name,
    type,
    placeholder,
    isItalic = false,
    control,
    biggerSelect,
    setBookingTime,
    bookingTime,
    date,
    setDate,
    setBookingData,
    bookingDays,
    calendar,
    time,
    form,
    disableDate,

}) => {

    const datepickerSpan = useRef(null);
    const [datePresent, setDatePresent] = useState(false);
    const isMobile = useWindowResize("xl");



    const thisRef = useRef();
    const range = (start, stop, step = 1) =>
        Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
    const years = range(1900, getYear(new Date()) + 1, 1);
    const [dateLang, setDateLang] = useState("en");
    const dateLocales = {
        "en": en,
        "it": it,
        "fr": fr,
        "ja": ja,
        "ko": ko,
        "zh": zh,
        "ru": ru
    };
    const [months, setMonths] = useState([
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ]);


    const timeChange = (time) => {
        setBookingTime(time)
        //setRequiredData(time)
    };

    const bookingChange = (e) => {
        setBookingData({ placeholder: placeholder, value: e.value })
    };

    const colorStyles = {
        option: (styles, { isFocused, isSelected }) => {
            const bgColor = "#E9E9E9";
            const focusedColor = "#FFFFFF";
            const selectedColor = "#b1a38a";
            const textColor = "#1E1F23";

            if (isSelected) {
                return {
                    ...styles,
                    backgroundColor: selectedColor,
                    color: textColor,
                    fontWeight: "bold",
                    paddingTop: "1.2rem",
                    paddingBottom: "1.2rem"
                };
            }

            return {
                ...styles,
                color: textColor,
                fontWeight: isFocused ? "bold" : null,
                backgroundColor: isFocused ? focusedColor : bgColor,
                paddingTop: "1.2rem",
                paddingBottom: "1.2rem"
            };
        },
    };

    const formatDisableDate = disableDate.map(d => new Date(d))

    return (
        <div className={styles.Input} ref={thisRef}>
            <div>
                {text}
                <label
                    className={
                        styles.InputLabel + " " + (isItalic ? styles.italicInput : null)
                    }
                    style={{
                        border: type === "radio" ? "none" : null,
                        height: type === "radio" ? "fit-content" : null,
                    }}
                >
                    {calendar &&

                        <div className={styles.datePickerBooking}>
                            <Controller
                                control={control}
                                name={name}
                                rules={{ required: true }}
                                render={({ field: { onChange, onBlur, value } }) => (
                                    <ReactDatePicker
                                        filterDate={d => {
                                          if((d.getMonth() == 11 && (d.getDate() == 25 || d.getDate() == 26) ) || (d.getMonth() == 0 && d.getDate() == 1)) {
                                            return false; // Christmas
                                          }
                                          if(isEaster(d)) {
                                            return false; // Easter
                                          }
                                          return true;
                                        }}
                                        excludeDates={formatDisableDate}
                                        excludeDateIntervals={[{ start: subDays(new Date(), 5000), end: addDays(new Date(), 0) }]}
                                        open
                                        locale={dateLang}
                                        customInput={
                                            <input
                                                className={styles.inputContainer}
                                                style={{
                                                    backgroundImage:
                                                        'url("/assets/icons/calendar.svg")',
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: isMobile
                                                        ? "96% 50%"
                                                        : "95% 50%",
                                                    backgroundColor: "transparent",
                                                    height: "100%",
                                                    visibility: 'hidden'
                                                }}
                                                autoComplete="off"
                                            />
                                        }
                                        onClickOutside={() => {
                                            if (
                                                datepickerSpan.current.classList.contains(
                                                    styles.clicked
                                                )
                                            ) {
                                                datepickerSpan.current.classList.remove(
                                                    styles.clicked
                                                );
                                            }
                                            if (!value) {
                                                setDatePresent(false);
                                            } else {
                                                setDatePresent(true);
                                            }
                                            if (value) {
                                                datepickerSpan.current.classList.add(styles.clicked_);
                                            } else if (
                                                datepickerSpan.current.classList.contains(
                                                    styles.clicked_
                                                )
                                            ) {
                                                datepickerSpan.current.classList.remove(
                                                    styles.clicked_
                                                );
                                            }
                                        }}

                                        onInputClick={() => {
                                            if (!value) return;
                                            const year = value.getFullYear();
                                            const month = (value.getMonth() + 1).toString().padStart(2, "0");
                                            const day = value.getDate().toString().padStart(2, "0");
                                            const newDate = year + '-' + month + '-' + day
                                            setDate(newDate);
                                            setDatePresent(true);
                                        }}
                                        onSelect={() => {

                                        }}
                                        wrapperClassName="datepicker"
                                        onChange={onChange}
                                        onBlur={onBlur}
                                        selected={value ? value : null}
                                        dateFormat="dd/MM/yyyy"
                                        openToDate={addDays(new Date(), 0)}
                                    />
                                )}
                            />
                            <span className={styles.datePlaceholder} ref={datepickerSpan}>
                                {''}
                            </span>
                        </div>
                    }
                    {time &&
                        <div
                            className={`formSelect`}
                        >
                        </div>
                    }

                    {form &&
                        <div
                            className={`formSelect ${biggerSelect ? "biggerSelect" : null}`}
                        >
                            <Select
                                components={{ DropdownIndicator }}
                                styles={colorStyles}
                                isSearchable={false}
                                instanceId="select-mobile"
                                classNamePrefix={styles.localeSelect}
                                className={styles.localeSelect}
                                options={''}
                                defaultValue={bookingTime}
                                onChange={bookingChange}
                                placeholder={''}
                            />
                            <span className={styles.selectPlaceholder}>{placeholder}</span>
                        </div>
                    }

                </label>
            </div>
        </div>
    );
};

export default InputBooking;


function isEaster(dateObject) {
  let y=dateObject.getFullYear();

  var date, a, b, c, m, d;

  // Instantiate the date object.
  date = new Date;

  // Set the timestamp to midnight.
  date.setHours( 0, 0, 0, 0 );

  // Set the year.
  date.setFullYear( y );

  // Find the golden number.
  a = y % 19;

  // Choose which version of the algorithm to use based on the given year.
  b = ( 2200 <= y && y <= 2299 ) ?
      ( ( 11 * a ) + 4 ) % 30 :
      ( ( 11 * a ) + 5 ) % 30;

  // Determine whether or not to compensate for the previous step.
  c = ( ( b === 0 ) || ( b === 1 && a > 10 ) ) ?
      ( b + 1 ) :
      b;

  // Use c first to find the month: April or March.
  m = ( 1 <= c && c <= 19 ) ? 3 : 2;

  // Then use c to find the full moon after the northward equinox.
  d = ( 50 - c ) % 31;

  // Mark the date of that full moon�the "Paschal" full moon.
  date.setMonth( m, d );

  // Count forward the number of days until the following Sunday (Easter).
  date.setMonth( m, d + ( 7 - date.getDay() ) );

  return date.getDate() == dateObject.getDate() && date.getMonth() == dateObject.getMonth();
  // Gregorian Western Easter Sunday
  //return date;
}